import {
  initChart,
  printNoDataChart,
  printDataChart,
  resultsetWithFields,
  formatTooltip,
  addPointInteger,
  capitalizarTexto
} from 'vlcishared';
import { TEXTS_SEGURIDAD_DETAIL } from './texts';
import { COLORS } from '../colors';
import { optionFranjaHoraria, optionsEvolucionMensual } from './options-charts';
import { DEFAULT_LANGUAGE } from '../common-language';

export function echartEvolucionMensual(datos) {
  const idChart = 'chart_EvolucionMensual';
  const idNoData = 'no_data_EvolucionMnesual';
  const chartOptions = JSON.parse(JSON.stringify(optionsEvolucionMensual));
  chartOptions.yAxis[0].axisLabel.formatter =
    optionsEvolucionMensual.yAxis[0].axisLabel.formatter;

  if (datos.resultset.length === 0) {
    printNoDataChart(`#${idChart}`, `#${idNoData}`);
  } else {
    printDataChart(`#${idNoData}`, `#${idChart}`);

    const seriesMap = {};
    const groupedData = {};

    const resultSet = resultsetWithFields(datos);

    resultSet.forEach((row) => {
      const tipologiaNivel1 = row.tipologia_nivel_1 || 'N/D';
      if (!groupedData[row.mes]) {
        groupedData[row.mes] = {};
        chartOptions.xAxis[0].data.push(row.mes);
      }
      groupedData[row.mes][tipologiaNivel1] = row.total_intervenciones;

      if (!chartOptions.legend.data.includes(tipologiaNivel1)) {
        chartOptions.legend.data.push(tipologiaNivel1);
        seriesMap[tipologiaNivel1] = {
          name: tipologiaNivel1,
          type: 'bar',
          barMaxWidth: 28,
          stack: 'total',
          data: [],
        };
      }
    });

    chartOptions.xAxis[0].data.forEach((time) => {
      chartOptions.legend.data.forEach((cat) => {
        seriesMap[cat].data.push(groupedData[time][cat] || 0);
      });
    });

    chartOptions.series = Object.values(seriesMap);
    chartOptions.tooltip.formatter = (params) => {
      return capitalizarTexto(formatTooltip(params));
    };
    initChart(idChart, chartOptions);
  }
}

export function echartFranjaHoraria(datos) {
  const colorMapping = {
    Mañana: COLORS.amarilloPalido,
    Tarde: COLORS.naranjaPalido,
    Noche: COLORS.azulCeruleo,
  };

  const seriesData = datos.resultset.map((row) => ({
    name: row[0],
    type: 'bar',
    barMaxWidth: 160,
    stack: 'total',
    data: [row[2]],
    itemStyle: {
      color: colorMapping[row[0]],
    },
    emphasis: {
      focus: 'series',
    },
    label: {
      show: true,
      formatter: (param) => `${param.seriesName}\n${addPointInteger(param.value)} ${TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('intervenciones')} `,
      textStyle: {
        fontFamily: 'Montserrat',
        fontWeight: 500,
      },
    },
  }));

  // Asignar los datos generados a la opción de la gráfica
  optionFranjaHoraria.series = seriesData;

  // Inicializar la gráfica con la configuración actualizada
  initChart('chart_FranjaHoraria', optionFranjaHoraria);
}
